import React from 'react';
import './SectionQuote.scss';

const SectionQuote = () => {
  return (
    <div className='quote-container'>
        <p className='quote'>“Dept helped us tell our story through a bold new identity and a robust online experience. To the tone of 60% growth in online bookings in just one month”</p>
        <p className='quote-author'>MATTIJS TEN BRINK - CEO, TRANSAVIA</p>
    </div>
  )
}

export default SectionQuote